import {
  createSearchParams,
  URLSearchParamsInit,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import { LocationState } from 'types';

const useDocumentDetails = () => {
  const navigate = useNavigate();
  const { state, pathname } = useLocation();

  const { searchParams, selectedTab } = (state || {}) as LocationState;

  const onBack = () =>
    navigate(
      {
        pathname: pathname.split('/', 3).join('/'),
        search: `${createSearchParams((searchParams || {}) as URLSearchParamsInit)}`,
      },
      {
        state: { selectedTab },
      }
    );

  return { onBack };
};

export default useDocumentDetails;
